import {BridgeSend, isMobile} from "../../event.js";
import * as DashboardApi from "../../../../apiCall/dashboard/index.js";
import {updateBadgeOnChattingItem} from "./item.js";

export const chatClickEvent = (e) => {
    const $eTarget = $(e.target);
    if ($eTarget.closest(".js-chatting-item").length > 0) {
        const $chattingItem = $eTarget.closest(".js-chatting-item");
        const CHAT_ROOM_SRNO = $chattingItem.attr('data-room-srno').split("-")[0];
        if (!CHAT_ROOM_SRNO) return;

        if (isMobile) {
            const jsonData = {CODE: "CHATTING", CHAT_ROOM_SRNO};
            BridgeSend(jsonData);
        } else {
            getRoomInfo(true, CHAT_ROOM_SRNO, (dat) => {
                readMessageAndOpenMessenger(dat.READ_OVER_YN !== 'N', CHAT_ROOM_SRNO)
            })
        }
    }

    if ($eTarget.closest('.js-new-chat').length > 0) {
        if (isMobile) {
            const jsonData = {CODE: "NEW_CHATTING"};
            BridgeSend(jsonData);
        } else {
            MessengerApi.createNewChatting(false);
        }
    }
}

/*채팅방 정보를 가져오는 함수*/
const getRoomInfo = async (isExecute, roomSrno, callback) => {
    const chatRoomInfo = {};
    if (!isExecute) {
        const roomInfoData = LocalUtil.getLocalJson("ONLY_MESSENGER-" + roomSrno);
        const isExistsRoomInfo = Often.null2Void(roomInfoData) !== "";

        if (isExistsRoomInfo && ServerChecker.isKyowon && roomInfoData.ROOM_GB == '1' && roomInfoData.SENDIENCE_LIST) {
            chatRoomInfo.SENDIENCE = roomInfoData.SENDIENCE_LIST.toString().replace(/\{|\}/g, "").trim().split(',');
            chatRoomInfo.ROOM_GB = roomInfoData.ROOM_GB;
            if (Often.isAct('messenger')) SocketControl.initStatusSocket();
        }
        if (isExistsRoomInfo) return (typeof callback === 'function') && callback(roomInfoData);
    }
    await DashboardApi.getApi('getChatData', ({
        ROOM_SRNO: roomSrno,
        PG_NO: 1,
    })).then((dat) => {
        dat.LAST_ROOM_CHAT_SRNO = dat.ROOM_CHAT_SRNO;
        /**
         * @Note.
         *  '마지막 메시지'의 여부를 확인하기 위해 소켓으로 수신한 뒤 실시간 수정이 필요한 경우에는
         *  ROOM_CHAT_SRNO가 아닌 LAST_ROOM_CHAT_SRNO를 갱신한다!!!!
         *
         *  roomInfo의 ROOM_CHAT_SRNO는 DB에서 호출된 상태로 그대로 유지하는 것을 default로 함.
         */
        LocalUtil.setLocalJson("ONLY_MESSENGER-" + roomSrno, dat);

        if (ServerChecker.isKyowon && dat.ROOM_GB == "1" && dat.SENDIENCE_LIST) {
            chatRoomInfo.SENDIENCE = dat.SENDIENCE_LIST.toString().replace(/\{|\}/g, "").trim().split(',');
            chatRoomInfo.ROOM_GB = dat.ROOM_GB;
            if (Often.isAct('messenger')) SocketControl.initStatusSocket();
        }

        (typeof callback === 'function') && callback(dat);
    })
}


/*채팅방 읽음 처리 + 채팅방 열림 함수*/
const readMessageAndOpenMessenger = (isReadOverExist, roomSrno) => {
    updateBadgeOnChattingItem($(`#chatting-${roomSrno}-widget`), 0);
    if (!isReadOverExist) return OpenUtil.openMessengerByRoomSrno(roomSrno);
    OpenUtil.openMessengerByRoomSrno(roomSrno);
}
